var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"panel",attrs:{"data-has-border":_vm.hasBorder,"data-transparent-bg":_vm.transparentBg},on:{"click":function($event){return _setup.emits('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }